import PendingRx from '../../../component/Pmc/PendingRx/PendixRx'

const PmsPendingRx = () => {
  return(
    <>
    <PendingRx />
    </>
  )
}

export default  PmsPendingRx
